module.exports = __webpack_public_path__ + "images/daewoo_small8f69e99b8ea73d295939c2ef0621e52b.png";